import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';
import MarkdownParser from '../MarkdownParser';
import Container from '../Container';
import { H1 } from '../Heading';
import Waypoint from '../Waypoint';
// import Brush from '../../svg/circle-2.svg';
import { ReactComponent as Arrow } from '../../svg/arrow-3.svg';
// import AnimateSvg from '../../utilities/animateSvg';

const StyledContainer = styled.div`
  position: relative;
  /* background-color: #6396da; */
`;

const StyledH1 = styled(H1)`
  color: ${props => props.theme.colors.merciless};
  font-size: 4.2em;
  line-height: 1.2;
  width: 60%;
  /* margin: 2em auto -5em; */
  // margin: 10vw auto -25vw;
  margin: 0;
  padding: 0;
  position: absolute;
  left: 1em;
  bottom: 1em;
  z-index: 2;
  /* position: relative; */
  /* background-color: ${props => props.theme.colors.white}; */

  /** White overlay */
  &:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.colors.white};
    z-index: -1;    
    top: 0.1em;
  }


  @media screen and (min-height: 10em) and (min-width: 64em) {
    font-size: 5.2em;
  }

  // medium = 64em
  @media ${props => props.theme.breakpoints.medium} {
    font-size: 3em;
    font-size: 7vw;
  }

  @media screen and (max-width: 50em) {
    font-size: 2.5em;
  }

  // small = 35em
  @media ${props => props.theme.breakpoints.small} {
    font-size: 2em;
  }

  span {
    /* color: ${props => props.theme.colors.merciless};
    display: block;
    font-size: 0.4em;
    font-family: ${props => props.theme.fonts.galanoGrotesque};
    padding: 0.3em 1em;
    margin-bottom: 0.5em;
    opacity: ${props => (props.shouldAnimate ? 1 : 0)}; */
    /* transition: opacity 2s ease-in; */
  }

  span.highlight {
    background-color: ${props => props.theme.colors.sizzle};
    color: inherit !important;
    padding: 0 !important;
    display: inline !important;
    font-size: 1em !important;
  }

  p {
    transform-origin: 50% 100%;
    opacity: ${props => (props.shouldAnimate ? 1 : 0)};
    transform: ${props =>
      props.shouldAnimate ? 'translateY(0);' : 'translateY(-0.3em);'};
    transition: opacity 2s ease-in-out,
      transform 1s cubic-bezier(0.69, 0.05, 0.53, 0.99);
  }
`;

export const HeroStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  /* min-width: 100vw; */
  min-width: 100%;
  // min-height: ${props => (props.height ? props.height : '100vh')};
  background-image: ${props =>
    props.backgroundImage ? `url(${props.backgroundImage})` : null};
  background-size: ${props =>
    props.backgroundSize ? props.backgroundSize : 'contain'};
  background-repeat: no-repeat;
  background-position: center bottom;
  color: ${props => props.theme.colors.white};
  /* margin-bottom: 6em; */

  /** Avoid some real bad screen jank before the hero image loads: */
  ${({ heroImageHasLoaded }) =>
    !heroImageHasLoaded &&
    css`
      min-height: 100vh;
    `}
`;

const StyledImg = styled.img`
  /* width: 100%; */
  width: 100vw;
  // margin-top: -3.5em;
  position: relative;
  z-index: 1;
  display: block;
`;

const StyledArrow = styled(Arrow)`
  /* position: absolute; */
  /* left: 50%; */
  /* bottom: 0; */
  /* transform: translateX(-50%); */
  color: ${props => props.theme.colors.merciless};
  height: 10em;
  bottom: -6em;
  z-index: 10;
  position: relative;
  top: 0;
  left: -2em;
  transform: translateX(-100%);

  @media ${props => props.theme.breakpoints.large} {
    transform: translateX(-50%);
    max-width: 12em;
  }
  @media ${props => props.theme.breakpoints.medium} {
    transform: translateX(-10%);
    max-width: 10em;
  }
  @media ${props => props.theme.breakpoints.small} {
    max-width: 8em;
  }
  @media ${props => props.theme.breakpoints.small} {
    /* height: 7em; */
  }
`;

const Hero = ({ fields }) => {
  const [shouldAnimate, setAnimate] = useState(false);
  const [heroImageHasLoaded, setHeroImageHasLoaded] = useState(false);
  const {
    title,
    body,
    backgroundImage,
    foregroundImage,
    backgroundSize,
    height,
  } = fields;

  return (
    <>
      <HeroStyled
        backgroundImage={backgroundImage || null}
        height={height}
        size={backgroundSize}
        heroImageHasLoaded={heroImageHasLoaded}
      >
        <Waypoint
          topOffset="0"
          bottomOffset="0"
          onEnter={() => setAnimate(true)}
          onLeave={() => setAnimate(false)}
        >
          <StyledContainer>
            {title && (
              <StyledH1 shouldAnimate={shouldAnimate}>
                <MarkdownParser
                  overrides={{
                    p: { component: styled.span`` },
                    P: { component: styled.span`` },
                  }}
                >
                  {title}
                </MarkdownParser>
              </StyledH1>
            )}
            <Container shouldAnimate={shouldAnimate}>
              {body && <MarkdownParser>{body}</MarkdownParser>}
            </Container>
            {foregroundImage && (
              <StyledImg
                src={foregroundImage}
                onLoad={() => setHeroImageHasLoaded(true)}
              />
            )}
            {/* <AnimateSvg svg={StyledArrow} type="image/svg+xml" /> */}
          </StyledContainer>
        </Waypoint>
      </HeroStyled>
      <Container>
        <StyledArrow />
      </Container>
    </>
  );
};

// Hero.propTypes = {
//   fields: PropTypes.shape({
//     /** Body is the only required child of fields */
//     // body: PropTypes.string.isRequired,
//     backgroundImage:
//       PropTypes.string ||
//       PropTypes.shape({
//         fields: PropTypes.shape({
//           file: PropTypes.shape({
//             url: PropTypes.string.isRequired,
//           }).isRequired,
//         }).isRequired,
//       }),
//     foregroundImage: PropTypes.shape({
//       fields: PropTypes.shape({
//         file: PropTypes.shape({
//           url: PropTypes.string,
//         }),
//       }),
//     }),
//   }).isRequired,
// };

export default Hero;
